import React from "react";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import SplashScreen from "./layout/SplashScreen";
import ECommerce from "./pages/services/ECommerce";
import DigitalMarketing from "./pages/services/DigitalMarketing";
import WebDevelopment from "./pages/services/WebDevelopment";
import MobileApps from "./pages/services/MobileApps";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Vehicle_Bazar_PrivacyPolicy from "./pages/Vehicle_Bazar_PrivacyPolicy";
import DeleteUserAccount from "./pages/DeleteUserAccount";
import Data_Vault_App_Ads_txt from "./pages/Data_Vault_App_Ads_txt";


function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<SplashScreen />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<Products />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/vehicle-bazar-privacy-policy" element={<Vehicle_Bazar_PrivacyPolicy />} />
          <Route path="/delete-data-vault-account" element={<DeleteUserAccount />} />
          <Route path="/data-vault/app-ads.txt" element={<Data_Vault_App_Ads_txt />} />

          {/* services */}
          <Route path="/ecommerce" element={<ECommerce />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/mobile-apps" element={<MobileApps />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
